import React, { createContext, useContext, useState } from 'react';

const ScreenRecorderPlacement = createContext({ container: null, setContainer: () => {} });

export const ScreenRecorderPlacementProvider = ({ children }) => {
  const [container, setContainer] = useState(null);
  return (
    <ScreenRecorderPlacement.Provider value={{ container, setContainer }}>
      {children}
    </ScreenRecorderPlacement.Provider>
  );
};

export const useScreenRecorderPlacement = () => useContext(ScreenRecorderPlacement);
